import type { BlogPost } from '../scope/blog-post-scope';

// ----------------------------------------------------------------------

/**
 * 글 상세 아래 「Recent Posts」 — 받은 목록의 **뒤에서 4개**(4개 미만이면 전부).
 *
 * ⚠️ 정렬하지 않는다 — 라우트가 받은 `blog.posts.get` 결과 순서를 그대로 믿는다.
 */
export function pickRecentPosts(latestPosts: BlogPost[]): BlogPost[] {
  return latestPosts.slice(latestPosts.length - 4);
}
